import React from 'react';
import PlazasIntegradas from './PlazasIntegradas';

const PlazasPorCarreraUniversidad = ({ selectedCarrera, selectedUniversidad, filtrosActivos = {} }) => {
  return (
    <PlazasIntegradas 
      selectedCarrera={selectedCarrera}
      selectedUniversidad={selectedUniversidad}
      filtrosActivos={filtrosActivos}
    />
  );
};

export default PlazasPorCarreraUniversidad;
